import templateUrl from "emun.media/media-gallery.htm";
import controller from "emun.media/media-gallery.controller";

export default {
	bindings: {
		realm: "@",
		shard: "@",
		media: "<?",
		results: "=?",
		mediaIds: "<?",
		exclude: "<?",
		take: "<?",
		tagCriteria: "<?",
		onMediaSelected: "&",
		search: "@",
		slidesToShow: "<",
		slidesToScroll: "<",
		arrows: "<",
		dots: "<",
		tagId: "@"
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	},
};
